export default "__VITE_ASSET__CFa_nH4H__"